/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';

export const RemovableItem = ({ label, remove, className }) => {

    return <div className={className}>
        {label}
        {remove && <span className={"svg-cross-black75-xs"} onClick={remove}/>}
        {!remove && <span style={{marginLeft: "3px"}}></span>}
    </div>

};
